<template>
  <iColumn gap="small" width="fill">
    <iRow
      v-for="(channel, idx) in placeholderChannels"
      :key="idx"
      gap="small"
      vertical-align="middle"
      width="fill"
      :style-overrides="{
        paddingTop: 'small',
        paddingBottom: 'small',
        paddingLeft: 'small',
        paddingRight: 'small',
        borderRadius: 'standard',
        backgroundColor: '#f4f5f7',
      }"
    >
      <iText># {{ channel.name }}</iText>
      <iText variant="subtle" font-size="small">
        {{ channel.members }} members
      </iText>
    </iRow>
  </iColumn>
</template>

<script>
// `%/components/community/chatrooms/slack-style/ChannelList.vue` lives
// outside the editor directory tree and the real channel list hits
// `/api/v1/{publication}/channel/{id}/users/smart-feed` which 500s in
// Studio (no publication context). Canvas preview shows a static
// channel list so the element stays self-contained inside the
// editor boundary.
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import MaxWidth from "%/dynamic-component-editor/options/max-width";
import MaxHeight from "%/dynamic-component-editor/options/max-height";
import MinWidth from "%/dynamic-component-editor/options/min-width";
import MinHeight from "%/dynamic-component-editor/options/min-height";

export default {
  name: "ListOfChannels",
  mixins: [DynamicElementMixin],
  data() {
    return {
      MinHeight,
      MinWidth,
      MaxHeight,
      MaxWidth,
      LayoutHeight,
      LayoutWidth,
    };
  },
  elementPanelSettings: {
    displayName: "List Of Channels",
    displayIcon: "list",
    elementGroup: "chatRoomElements",
    elementType: "element",
  },
  optionBundles: [
    LayoutWidthHeightOptions,
  ],
  computed: {
    placeholderChannels() {
      return [
        { name: "general", members: 142 },
        { name: "announcements", members: 142 },
        { name: "support", members: 87 },
      ];
    },
  },
};
</script>
